export class TransactionQuery {
    LoanNumber: string;
    MinimumDate: Date;
    MaximumDate: Date;
    Type: string;
    Program: string;
}
